import React, { useMemo } from 'react'
import { useRouteMatch } from 'react-router-dom'

import isNil from 'lodash/isNil'
import toUpper from 'lodash/toUpper'

import { useT } from '@galo-monitor/i18n'
import useGaloMonitorApi from '@galo-monitor/services/hooks/useGaloMonitorApi'
import { CircularLoader } from '@galo-monitor/web-components/Loader'
import Screen from '@galo-monitor/web-components/Screen'
import TabsPanelRoutes from '@galo-monitor/web-components/TabsPanelRoutes'
import { useRoutes } from '@galo-monitor/web-containers/routes/authenticated'

import Users from './tabs/Users'

const SelectedCompanyScreen = () => {
  const { routes, urlHasPermission } = useRoutes()
  const { params } = useRouteMatch()
  const t = useT()

  const { data: company } = useGaloMonitorApi(`/admin/companies/${ params.companyId }`)

  const companyName = useMemo(() => company?.nameCompany ?? '', [company])

  const tabs = useMemo(
    () => {
      const response = []

      const addTab = tab => {
        if (urlHasPermission(tab.slug, 'root')) {
          response.push(tab)
        }
      }

      addTab({
        route: 'users',
        slug: 'gerenciamento-de-usuarios-company',
        title: toUpper(t('user', { howMany: 2 })),
        Component: Users,
        ComponentProps: {
          companyId: params.companyId
        }
      })

      return response
    },
    [params.companyId, t, urlHasPermission]
  )

  const crumbs = useMemo(() => [
    {
      title: routes.companies.title,
      key: 'companies-screen',
      url: '/companies',
      active: true
    },
    {
      title: companyName,
      key: 'selected-company-screen',
      url: `/companies/${ params.companyId }`,
      active: true
    }
  ], [companyName, params.companyId, routes.companies.title])

  return isNil(company) ? (
    <CircularLoader label={ t('loading company data') } />
  ) : (
    <Screen title={ companyName } breadcrumbs={ crumbs } removeDivider>
      <TabsPanelRoutes itens={ tabs } />
    </Screen>
  )
}

export default SelectedCompanyScreen
